import { combineReducers } from 'redux';
import { addItemsModalReducer } from 'store/Modals/AddItems/reducer';
import { generalModalsReducer } from 'store/Modals/General/reducer';
import { advancedFiltersModalReducer } from 'store/AdvancedFilters/reducer';

export const modalsReducer = combineReducers({
    general: generalModalsReducer,
    addItems: addItemsModalReducer,
});